import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import moment from 'moment';
import { Col } from 'react-bootstrap';

import LogEntryListWidget from './LogEntryListWidget';
import TaskListWidget from './TaskListWidget';

import floatingTaskActions from '../actions/floatingTaskActionCreators';
import * as logEntryActions from '../actions/logEntryActionCreators';
import projectActions from '../actions/projectActionCreators';
import taskActions from '../actions/taskActionCreators';
import timesheetActions from '../actions/timesheetActionCreators';
import userActions from '../actions/userActionCreators';

import roles from '../utils/roles';

require.ensure([], () => {
    require('./LogEntryAdder.less');
});

class LogEntryAdder extends React.Component {

    constructor(props, context) {
        super(props, context);

        let queryParams = this.props.routeParams;

        this.state = {
            date: queryParams.date ? moment(queryParams.date, "YYYY-MM-DD") : moment(),
            user: this.props.currentUser || this.props.user,
            fillTaskForLogEntry: null
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        this.props.dispatch(projectActions.setCurrentView("LOG_OVERVIEW"));
        this.props.dispatch(taskActions.loadTasks());
        this.props.dispatch(taskActions.loadOthers());
        this.props.dispatch(taskActions.loadFavorite());
        this.props.dispatch(taskActions.loadRecentlyAssigned());
        this.props.dispatch(taskActions.loadMostFrequentlyUsed());
        this.props.dispatch(logEntryActions.loadOnDate(this.state.date));
        this.props.dispatch(floatingTaskActions.loadAll());
        this.props.dispatch(projectActions.loadProjects());
    }

    componentDidMount = () => {
        moment.updateLocale('en', {
            week: { doy: 4 }
        });

        if(!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['USER'])) {
            browserHistory.push('/');
        }

        this.props.dispatch(userActions.loadPms());
        this.loadTimesheet();
    }

    componentWillReceiveProps = (nextProps) => {
        if (!this.state.user) {
            this.setState({
                user: nextProps.user
            });
        }
    }

    // EVENT HANDLERS

    handleDateChange = (date) => {
        moment.updateLocale('en', {
            week: { doy: 4, dow: 1 }
        });

        this.setState({
            date: moment(date, "YYYY-MM-DD")
        }, () => {
            this.props.dispatch(logEntryActions.loadOnDate(this.state.date));
            this.loadTimesheet();
        });

    }

    // OTHER METHODS

    createLogEntry = (logEntry) => {
        // append selected date
        logEntry.date = this.state.date.format("YYYY-MM-DD");

        // empty the fill task
        this.setState({
            fillTaskForLogEntry: null
        });

        this.props.dispatch(logEntryActions.create(logEntry));

        if (logEntry && logEntry.task && logEntry.task.indexOf('floatingTask') !== -1) {
            setTimeout(this.props.dispatch(floatingTaskActions.loadAll), 500);
        }

        setTimeout(this.loadTimesheet, 500);
    }

    createTimer  = (task, logEntry) => {
        // stop timers locally so we're synced with the backend
        for (let i = this.props.logEntries.length - 1; i >= 0; --i) {
            if (this.props.logEntries[i].timer) {
                // calculate mock duration until the user refreshes or forces a reload
                let currentTime = moment();
                let startTime =  moment(this.props.logEntries[i].startTime, ["HH:mm:ss", "HH:mm"]);
                this.props.logEntries[i].duration = Math.floor(60 * (currentTime.hours() - startTime.hours())
                                      + (currentTime.minutes() - startTime.minutes()));

                // set minimum duration to 1 minute because 0 duration is not shown in the duration set pill component
                if (this.props.logEntries[i].duration === 0)
                    this.props.logEntries[i].duration = 1;

                this.props.logEntries[i].timer = false;
            }
        }

        if (task.projectName)
            this.props.dispatch(taskActions.createTimer(task, logEntry));
        else
            this.props.dispatch(floatingTaskActions.createTimer(task, logEntry));
    }

    decrementDate = () => {
        this.state.date.subtract(1, 'day');

        this.setState({
            date: this.state.date
        }, () => {
            this.props.dispatch(logEntryActions.loadOnDate(this.state.date));
            this.loadTimesheet();
        });
    }

    incrementDate = () => {
        this.state.date.add(1, 'day');

        this.setState({
            date: this.state.date
        }, () => {
            this.props.dispatch(logEntryActions.loadOnDate(this.state.date));
            this.loadTimesheet();
        });
    }

    loadTimesheet = () => {
      let weekStart = this.state.date.clone().startOf('isoweek');
        if (this.props.currentUser) {
            this.props.dispatch(timesheetActions.loadByUserWeek(
                this.props.currentUser,
                ("" + weekStart.year()) + (weekStart.isoWeek() > 9
                    ? "" + weekStart.isoWeek()
                    :  (weekStart.year() !== weekStart.clone().add(6, 'days').year() ? "53" : "0" + weekStart.isoWeek()))
            ));
        }
    }

    setDate (newDate) {
        this.setState({
            date: newDate
        }, this.props.dispatch(logEntryActions.loadOnDate(this.state.date)));
    }

    setFillTaskForLogEntry = (task) => {
        this.setState({
            fillTaskForLogEntry: task
        });
    }

    updateLogEntry = (logEntry) => {
        if (logEntry.date === null) {
            logEntry.date = this.state.date.format("YYYY-MM-DD");
        }

        this.props.dispatch(logEntryActions.update(logEntry));
        setTimeout(this.loadTimesheet, 1000);
    }

    // RENDER METHOD

    render = () => {
        return (
            <div className="main">
                <div className="row">
                    <Col>
                        <TaskListWidget
                            createTimer={this.createTimer}
                            currentUser={this.props.currentUser}
                            date={this.state.date}
                            favoriteTasks={this.props.favoriteTasks}
                            floatingTasks={this.props.floatingTasks}
                            infoUserTask={this.props.infoUserTask}
                            loading={this.props.loadingTasks}
                            mostFrequentlyUsedTasks={this.props.mostFrequentlyUsedTasks}
                            otherTasks={this.props.otherTasks}
                            pms={this.props.pms}
                            recentlyAssignedTasks={this.props.recentlyAssignedTasks}
                            setFillTaskForLogEntry={this.setFillTaskForLogEntry}
                            timesheet={this.props.timesheet}
                            />
                    </Col>

                    <Col lg={8} lgOffset={2} md={10} mdOffset={1} sm={12}>
                        <LogEntryListWidget
                            createLogEntry={this.createLogEntry}
                            date={this.state.date}
                            decrementDate={this.decrementDate}
                            fillTaskForLogEntry={this.state.fillTaskForLogEntry}
                            floatingTasks={this.props.floatingTasks}
                            handleDateChange={this.handleDateChange}
                            incrementDate={this.incrementDate}
                            infoUserTask={this.props.infoUserTask}
                            loadTimesheet={this.loadTimesheet}
                            loading={this.props.loadingLogEntries}
                            logEntries={this.props.logEntries}
                            setDate={this.setDate}
                            setFillTaskForLogEntry={this.setFillTaskForLogEntry}
                            updateLogEntry={this.updateLogEntry}
                            ref="LogEntryListWidget"
                            tasks={this.props.tasks}
                            timesheet={this.props.timesheet}
                            />
                    </Col>
                </div>
            </div>
        );
    }
}

LogEntryAdder.contextTypes = {
    router: PropTypes.object.isRequired
};

LogEntryAdder.propTypes = {
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    routeParams: PropTypes.object,
    user: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        favoriteTasks: state.tasks.favoriteTasks,
        floatingTasks: state.floatingTasks.allFloatingTasks,
        logEntries: state.logEntries.logEntriesOnDate,
        infoUserTask: state.userTasks.userTaskByID ? state.userTasks.userTaskByID.userTask : null,
        loadingTasks: state.tasks.loading || state.users.loading,
        loadingLogEntries: state.logEntries.loading,
        mostFrequentlyUsedTasks: state.tasks.mostFrequentlyUsedTasks,
        otherTasks: state.tasks.otherTasks,
        pms: state.users.pms.users,
        recentlyAssignedTasks: state.tasks.recentlyAssignedTasks,
        tasks: state.tasks.tasks,
        timesheet: state.timesheets.currentTimesheet
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(LogEntryAdder);



/** WEBPACK FOOTER **
 ** ./src/app/components/LogEntryAdder.js
 **/